module.exports = __webpack_public_path__ + "static/media/pencil.870eafc1.svg";